// Section 5: Frail. Health loss at 1.4x; illness risk 1.3x. Constants: config.traits.frail.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function frail(config: Config) {
  return defineTrait({
    id: 'frail',
    label: 'Frail',
    section: 'S5',
    modifierTargets: ['healthLoss', 'illnessRisk'],
    modifiers(ctx, target) {
      if (targetPerson(ctx, target)?.traits.includes('frail') !== true) return [];
      if (target.kind === 'healthLoss')
        return [mod.mul('trait:frail', config.traits.frail.healthLossMul, 'frail')];
      if (target.kind === 'illnessRisk')
        return [mod.mul('trait:frail', config.traits.frail.illnessMul, 'frail')];
      return [];
    },
    restricts: neverRestricts,
  });
}
